export const ERR_LOGIN = {
  WRONG_CRIDENTIALS: 'Не верная пара логин/пароль.'
}
export const ERR_COMMON = {
  CONNECTION_REFUSED: 'Не удалось установить соединение с сервером, повторите попытку позже.'
}



// WEBPACK FOOTER //
// ./src/constants/errorMessages.js